<template>
  <div id="_qlqn_admin_sample_group_spl_ls" class="bg-white q-pa-md">
    <div class="fit column justify-center items-center" v-if="loading">
      <Loading />
    </div>
    <div class="fit column no-wrap" v-else-if="groupDetail">
      <header class="row no-wrap justify-between items-center">
        <div class="row items-center">
          <span
            style="font-size: 1.2rem"
            class="text-bold"
            :title="groupDetail.name"
          >
            {{ groupDetail.name.substr(0, 10) }}
            {{ groupDetail.name.length > 10 ? "..." : "" }}
          </span>
          <span class="text-grey text-caption row items-center  cursor-pointer">
            <q-icon name="fas fa-edit" class="q-mx-sm" />
            <span>修改样本组名称</span>
            <q-popup-edit
              :disable="adminStatusStore[REMOVING_SAMPLE_GROUP_SAMPLES]"
              v-model="editGroupNameInput"
              dense
              buttons
              persistent
              title="修改样本组名称"
              label-set="修改"
              label-cancel="取消"
              anchor="top right"
              @save="(value) => updateGroupInfo({ name: value }, true)"
              @before-show="editGroupNameInput = groupDetail.name"
            >
              <q-input filled dense autofocus v-model="editGroupNameInput" />
            </q-popup-edit>
          </span>
        </div>

        <!-- link -->
        <q-icon name="fas fa-link" size="12px"></q-icon>

        <!-- 用户组 -->
        <div class="row items-center">
          <span v-if="groupDetail.user_group">
            {{ groupDetail.user_group.name }}
          </span>
          <span class="text-grey text-caption" v-else>未指定用户小组</span>
          <span
            class="text-grey text-caption row items-center  cursor-pointer"
            @click="showBindUserGroupDialog = true"
          >
            <q-icon name="fas fa-edit" class="q-mx-sm cursor-pointer" />
            <span>修改绑定的小组</span>
          </span>
        </div>
      </header>

      <!-- 描述 -->
      <section
        style="height: 200px;"
        class="row full-width no-wrap justify-between items-center q-py-md"
      >
        <div
          style="width: 70%"
          class="text-grey-7 row items-center row no-wrap"
        >
          <div style="white-space: pre-wrap;">
            {{ groupDetail.description }}
          </div>
          <div
            class="row items-center justify-center bg-white cursor-pointer q-ml-md"
            style="width: 36px;height: 36px;border-radius: 10px;flex-shrink: 0"
          >
            <q-icon name="fas fa-edit" size="12px" />
            <q-popup-edit
              :disable="adminStatusStore[REMOVING_SAMPLE_GROUP_SAMPLES]"
              v-model="editGroupDescInput"
              max-width="400px"
              content-style="width: 360px"
              dense
              buttons
              persistent
              title="修改样本组描述"
              label-set="修改"
              label-cancel="取消"
              anchor="top right"
              @save="(value) => updateGroupInfo({ description: value })"
              @before-show="editGroupDescInput = groupDetail.description"
            >
              <q-input
                type="textarea"
                filled
                dense
                autofocus
                v-model="editGroupDescInput"
              />
            </q-popup-edit>
          </div>
        </div>

        <!-- 总体进度 -->
        <div
          style="width: 45%; flex-shrink: 0"
          class="column no-wrap items-end "
        >
          <span class="text-caption q-mb-sm">样本组完成的总体情况</span>
          <span
            class="text-grey text-caption q-py-md"
            v-if="isNaN(groupProgress.NOT_STARTED)"
          >
            组长未分配样本
          </span>
          <div v-else class="row no-wrap items-center">
            <div class="column items-center q-ml-sm">
              <span class="text-grey text-caption">未开始</span>
              <q-circular-progress
                show-value
                class="text-red "
                :value="groupProgress.NOT_STARTED || 0"
                size="50px"
                track-color="grey-4"
                color="red"
              >
                {{ groupProgress.NOT_STARTED || 0 }}%
              </q-circular-progress>
            </div>
            <div class="column items-center q-ml-sm">
              <span class="text-grey text-caption">进行中</span>
              <q-circular-progress
                show-value
                class="text-primary"
                :value="groupProgress.STARTED || 0"
                size="50px"
                track-color="grey-4"
                color="primary"
              >
                {{ groupProgress.STARTED || 0 }}%
              </q-circular-progress>
            </div>
            <div class="column items-center q-ml-sm">
              <span class="text-grey text-caption">已完成</span>
              <q-circular-progress
                show-value
                class="text-green"
                :value="groupProgress.FINISHED || 0"
                size="50px"
                track-color="grey-4"
                color="green"
              >
                {{ groupProgress.FINISHED || 0 }}%
              </q-circular-progress>
            </div>
          </div>
        </div>
      </section>

      <SampleList
        class="col-grow"
        :group-id="groupDetail.id"
        :samples="groupDetail.samples"
        @updated="fetchGroupDetail($route.query._ug)"
        @deleted="resolveGroupDeleted"
      />
    </div>
    <div class="fit column justify-center items-center" v-else>
      <Empty
        :text="
          groupId
            ? '未找到分组，您可能没有访问的权限或分组已被删除'
            : '请在左侧选择一个分组'
        "
      />
    </div>

    <q-dialog v-model="showBindUserGroupDialog" persistent>
      <BindUserGroup
        v-if="groupDetail"
        :group-id="groupDetail.id"
        :band-group="groupDetail.user_group"
        @cancel="showBindUserGroupDialog = false"
        @updated="bindUserGroupSuccessed"
      />
    </q-dialog>
  </div>
</template>

<script>
import { getSampleGroupDetail } from "@/api/endpoints/sample-group/getSampleGroupDetail";
import { updateSampleGroup } from "@/api/endpoints/sample-group/updateSampleGroup";
import { EventBus } from "@/bus/index";
import {
  SAMPLE_GROUP_DETAIL_CHANGED,
  SAMPLE_GROUP_SAMPLES_DETAIL_CHANGE,
} from "@/bus/admin.events";
import { REMOVING_SAMPLE_GROUP_SAMPLES } from "@/status/admin.status";
import AdminCommonStatus from "@/views/Admin/mixins/status.mixin";
import SampleGroupMixin from "../sample-group.mixin";

export default {
  mixins: [AdminCommonStatus, SampleGroupMixin],
  components: {
    Loading: () => import("@/components/Loading"),
    Empty: () => import("@/components/Empty"),
    SampleList: () => import("./SampleList"),
    BindUserGroup: () => import("./BindUserGroup"),
  },
  data() {
    return {
      // groupDetail: null,
      loading: false,

      editGroupNameInput: "",
      editGroupDescInput: "",

      REMOVING_SAMPLE_GROUP_SAMPLES,

      showBindUserGroupDialog: false,
    };
  },

  mounted() {
    EventBus.$on(SAMPLE_GROUP_SAMPLES_DETAIL_CHANGE, this.fetchGroupDetail);
  },
  beforeDestroy() {
    EventBus.$off(SAMPLE_GROUP_SAMPLES_DETAIL_CHANGE, this.fetchGroupDetail);
  },

  computed: {
    groupId() {
      return this.$route.query._sg;
    },

    groupProgress() {
      const { groupDetail } = this;
      if (!groupDetail) return {};
      let started = 0,
        not_started = 0,
        finished = 0;
      const samples = groupDetail.samples || [];
      for (let sample of samples) {
        if (sample.sample_status == 1) not_started++;
        else if (sample.sample_status == 2) started++;
        else finished++;
      }
      return {
        NOT_STARTED: parseInt((not_started / samples.length) * 100),
        STARTED: parseInt((started / samples.length) * 100),
        FINISHED: parseInt((finished / samples.length) * 100),
      };
    },
  },

  watch: {
    groupId: {
      immediate: true,
      handler(id) {
        if (id) this.fetchGroupDetail(id);
      },
    },
  },

  methods: {
    /**
     * 获取分组详情
     */
    async fetchGroupDetail(groupId = this.groupId) {
      this.loading = true;
      this.groupDetail = null;
      try {
        const res = await getSampleGroupDetail(groupId);
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.messgae,
          });
        } else {
          // console.log(res);
          this.$set(this, "groupDetail", res);
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },

    /**
     * 更新分组的基本信息
     */
    async updateGroupInfo(info, refreshGroupList = false) {
      if (!info.name && !info.description) return;
      if (info.name && info.name === this.groupDetail.name) return;
      if (info.description && info.description === this.groupDetail.description)
        return;
      this.loading = true;
      try {
        const updateRes = await updateSampleGroup(this.groupDetail.id, info);
        if (updateRes.status || updateRes.error) {
          this.$q.notify({
            type: "danger",
            message: "更新分组信息失败",
          });
          this.loading = false;
        } else {
          this.$q.notify({
            type: "success",
            message: "分组信息已更新",
          });
          if (refreshGroupList) EventBus.$emit(SAMPLE_GROUP_DETAIL_CHANGED);

          await this.fetchGroupDetail(this.groupDetail.id);
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      } finally {
      }
    },

    /**
     * 分组删除以后的处理
     */
    resolveGroupDeleted() {
      EventBus.$emit(SAMPLE_GROUP_DETAIL_CHANGED);
      this.$router.replace({
        query: {
          ...this.$route.query,
          _ug: undefined,
          _gu: undefined,
        },
      });
      this.groupDetail = null;
    },

    bindUserGroupSuccessed() {
      this.showBindUserGroupDialog = false;
      this.fetchGroupDetail();
    },
  },
};
</script>

<style lang="scss">
#_qlqn_admin_sample_group_spl_ls {
  box-shadow: 20px 0px 20px rgba(0, 0, 0, 0.05),
    10px 0px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
}
</style>
